import Audio from '../Audio';
import Generic from '../Generic';
import Image from '../Image';
import Video from '../Video';

type ComponentKey = 'audio' | 'video' | 'image';

const componentsMap = {
    audio: Audio,
    image: Image,
    video: Video,
};

const getMediaComponent = (contentType?: string) => {
    const [type] = contentType?.split('/') || [];
    return componentsMap[type as ComponentKey] || Generic;
};

export default getMediaComponent;
